module.exports = __webpack_public_path__ + "static/media/file-excel.11158033.svg";